<p-confirmDialog [baseZIndex]="20000" appendTo="body"></p-confirmDialog>
<!-- Wrapper global -->
<div class="min-h-screen flex flex-column">

    <!-- Área de conteúdo que cresce -->
    <div class="flex-1">
        <ng-container *ngIf="isNativeAndroind; else webBranch">

            <!-- Nativo (Ionic) -->
            <ion-content>
                <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
                    <ion-refresher-content></ion-refresher-content>
                </ion-refresher>

                <app-p-meta-store></app-p-meta-store>
                <router-outlet></router-outlet>
            </ion-content>

        </ng-container>

        <!-- Web -->
        <ng-template #webBranch>
            <app-p-meta-store></app-p-meta-store>
            <router-outlet></router-outlet>
        </ng-template>
    </div>


</div>


<p-toast #toastEl></p-toast>
